import { render, staticRenderFns } from "./CallPostDialModal.vue?vue&type=template&id=239eb4fb&scoped=true&"
import script from "./CallPostDialModal.vue?vue&type=script&lang=js&"
export * from "./CallPostDialModal.vue?vue&type=script&lang=js&"
import style0 from "./CallPostDialModal.vue?vue&type=style&index=0&id=239eb4fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239eb4fb",
  null
  
)

export default component.exports